var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "header header-001" },
    [
      _c("page-header-search"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "secondary-region" },
        [
          _c("b-container", [
            _c(
              "div",
              { staticClass: "navbar navbar-expand-lg" },
              [
                _c(_vm.elementLogoComponent, { tag: "commponent" }),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  { attrs: { id: "nav_collapse", "is-nav": "" } },
                  [
                    _c("user-actions", {
                      attrs: { "help-active": _vm.helpActive },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(_vm.mobilenavcomponent, { tag: "component" }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "primary-region" },
        [
          _c(
            _vm.primaryWrapComponent,
            { tag: "component" },
            [
              _c(
                "b-navbar",
                {
                  class: _vm.desktopMenuDisplayPort,
                  attrs: { toggleable: "md" },
                },
                [_c("main-menu", { attrs: { "menu-style": "desktop" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }